import { stripeService, type BillingDetails } from '@/services/stripe';
import type { ICheckoutContext } from '@/types/context';
import type { StripeCardNumberElement } from '@stripe/stripe-js';
import { PaymentMethodEnum } from '@/types/common';
import { getBillingDetails } from '@/utils/paymentParams';
import { buildStripeSavedCreditCardPaymentRequest, buildStripeCreditCardPaymentRequest } from '@/utils/card';

export const handleStripeCardPayment = async (
  checkout: ICheckoutContext,
  sendPaymentToServer: (params: unknown) => Promise<unknown>,
  params: Record<string, unknown>
): Promise<unknown> => {
  const card = checkout.card.savedCards.find(
    (c) => c.pspCardIdentifier === checkout.card.selectedCard?.pspCardIdentifier
  );
  const { initialCardPayload } = checkout.card;
  if (card && !params.newCard) {
    return await sendPaymentToServer(
      buildStripeSavedCreditCardPaymentRequest(
        card,
        checkout.customer,
        checkout.paymentMethodsSettings.find((pm) => pm.paymentMethodName === PaymentMethodEnum.CREDIT_CARD)!
      )
    );
  }
  const billingDetails: BillingDetails = getBillingDetails(checkout.customer);

  const paymentMethod = await stripeService.createPaymentMethod(
    checkout.card.cardElementRef?.current as StripeCardNumberElement,
    billingDetails
  );

  const creditCardSettings = checkout.paymentMethodsSettings.find(
    (pm) => pm.paymentMethodName === PaymentMethodEnum.CREDIT_CARD
  );

  return await sendPaymentToServer(
    buildStripeCreditCardPaymentRequest(
      paymentMethod,
      creditCardSettings?.id || '',
      checkout.customer.email || '',
      initialCardPayload?.isSaveCard ?? false
    )
  );
};
